import Vue from 'vue'
import Router from 'vue-router'
import AuthGuard from './auth-guard'
import Access from './access-list'
import Home from '@/components/Home'
import Login from '@/components/Auth/Login'
import PasswordRecovery from '@/components/Auth/PasswordRecovery'
import PasswordRecoveryConfirm from '@/components/Auth/PasswordRecoveryConfirm'
import NotificationList from '@/components/Notifications/NotificationList'
import NotificationNew from '@/components/Notifications/NotificationNew'
import NotificationSingle from '@/components/Notifications/NotificationSingle'
import RestrictionList from '@/components/Restrictions/RestrictionList'
import RestrictionNew from '@/components/Restrictions/RestrictionNew'
import RestrictionSingle from '@/components/Restrictions/RestrictionSingle'
import CaseList from '@/components/Cases/CaseList'
import CaseNew from '@/components/Cases/CaseNew'
import CaseSingle from '@/components/Cases/CaseSingle'
import RecommendationList from '@/components/Recommendations/RecommendationList'
import RecommendationNew from '@/components/Recommendations/RecommendationNew'
import RecommendationSingle from '@/components/Recommendations/RecommendationSingle'
import MonitoringList from '@/components/Monitorings/MonitoringList'
import MonitoringNew from '@/components/Monitorings/MonitoringNew'
import MonitoringSingle from '@/components/Monitorings/MonitoringSingle'
import MonitoringReport from '@/components/Monitorings/MonitoringReport'
import UserList from '@/components/Users/UserList'
import UserNew from '@/components/Users/UserNew'
import UserSingle from '@/components/Users/UserSingle'
import UserGroupList from '@/components/Users/UserGroupList'
import UserGroupNew from '@/components/Users/UserGroupNew'
import UserSelfInfo from '@/components/Users/UserSelfInfo'
import UserSelfEdit from '@/components/Users/UserSelfEdit'
import AgentActivity from '@/components/Agents/AgentActivity'
import AgentRating from '@/components/Agents/AgentRating'
import AgentSingle from '@/components/Agents/AgentSingle'
import DriverActivity from '@/components/Drivers/DriverActivity'
import DriverRating from '@/components/Drivers/DriverRating'
import DriverSingle from '@/components/Drivers/DriverSingle'
import PointList from '@/components/Points/PointList'
import PointEdit from '@/components/Points/PointEdit'
import PointRequestList from '@/components/Points/PointRequestList'
import PointSingle from '@/components/Points/PointSingle'
import PointRequestLogisticsList from '@/components/Points/PointRequestLogisticsList'
import PointRequestSecurityList from '@/components/Points/PointRequestSecurityList'
import PointSecurityEdit from '@/components/Points/PointSecurityEdit'
import PointLogisticsEdit from '@/components/Points/PointLogisticsEdit'
import PointLogisticsSingle from '@/components/Points/PointLogisticsSingle'
import StatisticsBranch from '@/components/Statistics/StatisticsBranch'
import StatisticsSaleGroup from '@/components/Statistics/StatisticsSaleGroup'
import StatisticsAgent from '@/components/Statistics/StatisticsAgent'
import StatisticsDistributionChannel from '@/components/Statistics/StatisticsDistributionChannel'
import StatisticsPoint from '@/components/Statistics/StatisticsPoint'
import StatisticsProductCategory from '@/components/Statistics/StatisticsProductCategory'
import StatisticsProductBrand from '@/components/Statistics/StatisticsProductBrand'
import StatisticsProductSku from '@/components/Statistics/StatisticsProductSku'
import Settings from '@/components/Settings'
import Chat from '@/components/Chat'
import ProductStockSettingList from '@/components/ProductStockSetting/ProductStockSettingList'
import ProductStockSettingNew from '@/components/ProductStockSetting/ProductStockSettingNew'
import ProductStockSettingSingle from '@/components/ProductStockSetting/ProductStockSettingSingle'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        breadcrumbs: [
          {name: 'Главная'}
        ]
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/password-recovery',
      name: 'PasswordRecovery',
      component: PasswordRecovery
    },
    {
      path: '/password-recovery/confirm',
      name: 'PasswordRecoveryConfirm',
      component: PasswordRecoveryConfirm
    },
    {
      path: '/notifications/future/:page',
      name: 'NotificationFuture',
      component: NotificationList,
      meta: {
        accessId: Access.Notifications
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/notifications/future',
      redirect: '/notifications/future/1',
      beforeEnter: AuthGuard
    },
    {
      path: '/notifications/past/:page',
      name: 'NotificationPast',
      component: NotificationList,
      meta: {
        accessId: Access.Notifications
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/notifications/past',
      redirect: '/notifications/past/1',
      beforeEnter: AuthGuard
    },
    {
      path: '/notifications/new',
      name: 'NotificationNew',
      component: NotificationNew,
      meta: {
        accessId: Access.Notifications
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/notifications/edit/:id',
      name: 'NotificationEdit',
      component: NotificationNew,
      meta: {
        accessId: Access.Notifications
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/notifications/single/:id',
      name: 'NotificationSingle',
      component: NotificationSingle,
      meta: {
        accessId: Access.Notifications
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/restrictions/active',
      redirect: '/restrictions/active/1',
      beforeEnter: AuthGuard
    },
    {
      path: '/restrictions/active/:page',
      name: 'RestrictionActive',
      component: RestrictionList,
      meta: {
        accessId: Access.Restrictions
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/restrictions/past',
      redirect: '/restrictions/past/1',
      beforeEnter: AuthGuard
    },
    {
      path: '/restrictions/past/:page',
      name: 'RestrictionPast',
      component: RestrictionList,
      meta: {
        accessId: Access.Restrictions
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/restrictions/new',
      name: 'RestrictionNew',
      component: RestrictionNew,
      meta: {
        accessId: Access.Restrictions
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/restrictions/edit/:id',
      name: 'RestrictionEdit',
      component: RestrictionNew,
      meta: {
        accessId: Access.Restrictions
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/restrictions/single/:id',
      name: 'RestrictionSingle',
      component: RestrictionSingle,
      meta: {
        accessId: Access.Restrictions
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/cases/active',
      redirect: '/cases/active/1',
      beforeEnter: AuthGuard
    },
    {
      path: '/cases/active/:page',
      name: 'CaseActive',
      component: CaseList,
      meta: {
        accessId: Access.Cases
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/cases/past',
      redirect: '/cases/past/1',
      beforeEnter: AuthGuard
    },
    {
      path: '/cases/past/:page',
      name: 'CasePast',
      component: CaseList,
      meta: {
        accessId: Access.Cases
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/cases/new',
      name: 'CaseNew',
      component: CaseNew,
      meta: {
        accessId: Access.Cases
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/cases/edit/:id',
      name: 'CaseEdit',
      component: CaseNew,
      meta: {
        accessId: Access.Cases
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/cases/single/:id',
      name: 'CaseSingle',
      component: CaseSingle,
      meta: {
        accessId: Access.Cases
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/monitorings/active',
      redirect: '/monitorings/active/1',
      beforeEnter: AuthGuard
    },
    {
      path: '/monitorings/active/:page',
      name: 'MonitoringActive',
      component: MonitoringList,
      meta: {
        accessId: Access.Monitorings
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/monitorings/past',
      redirect: '/monitorings/past/1',
      beforeEnter: AuthGuard
    },
    {
      path: '/monitorings/past/:page',
      name: 'MonitoringPast',
      component: MonitoringList,
      meta: {
        accessId: Access.Monitorings
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/monitorings/new',
      name: 'MonitoringNew',
      component: MonitoringNew,
      meta: {
        accessId: Access.Monitorings
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/monitorings/report',
      name: 'MonitoringReport',
      component: MonitoringReport,
      meta: {
        accessId: Access.Monitorings
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/monitorings/edit/:id',
      name: 'MonitoringEdit',
      component: MonitoringNew,
      meta: {
        accessId: Access.Monitorings
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/monitorings/single/:id',
      name: 'MonitoringSingle',
      component: MonitoringSingle,
      meta: {
        accessId: Access.Monitorings
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/recommendations/active',
      redirect: '/recommendations/active/1',
      beforeEnter: AuthGuard
    },
    {
      path: '/recommendations/active/:page',
      name: 'RecommendationActive',
      component: RecommendationList,
      meta: {
        accessId: Access.Recommendations
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/recommendations/past',
      redirect: '/recommendations/past/1',
      beforeEnter: AuthGuard
    },
    {
      path: '/recommendations/past/:page',
      name: 'RecommendationPast',
      component: RecommendationList,
      meta: {
        accessId: Access.Recommendations
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/recommendations/new',
      name: 'RecommendationNew',
      component: RecommendationNew,
      meta: {
        accessId: Access.Recommendations
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/recommendations/edit/:id',
      name: 'RecommendationEdit',
      component: RecommendationNew,
      meta: {
        accessId: Access.Recommendations
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/recommendations/single/:id',
      name: 'RecommendationSingle',
      component: RecommendationSingle,
      meta: {
        accessId: Access.Recommendations
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/users/active',
      redirect: '/users/active/1',
      beforeEnter: AuthGuard
    },
    {
      path: '/users/active/:page',
      name: 'UserFuture',
      component: UserList,
      meta: {
        accessId: Access.Users
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/users/past',
      redirect: '/users/past/1',
      beforeEnter: AuthGuard
    },
    {
      path: '/users/past/:page',
      name: 'UserPast',
      component: UserList,
      meta: {
        accessId: Access.Users
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/users/new',
      name: 'UserNew',
      component: UserNew,
      meta: {
        accessId: Access.Users
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/users/edit/:id',
      name: 'UserEdit',
      component: UserNew,
      meta: {
        accessId: Access.Users
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/users/single/:id',
      name: 'UserSingle',
      component: UserSingle,
      meta: {
        accessId: Access.Users
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/users/group/list',
      name: 'UserGroupList',
      component: UserGroupList,
      meta: {
        accessId: Access.Groups
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/users/group/edit/:id',
      name: 'UserGroupEdit',
      component: UserGroupNew,
      meta: {
        accessId: Access.Groups
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/users/group/new',
      name: 'UserGroupNew',
      component: UserGroupNew,
      meta: {
        accessId: Access.Users
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/users/self/info',
      name: 'UserSelfInfo',
      component: UserSelfInfo,
      beforeEnter: AuthGuard
    },
    {
      path: '/users/self/edit',
      name: 'UserSelfEdit',
      component: UserSelfEdit,
      beforeEnter: AuthGuard
    },
    {
      path: '/agents/rating',
      name: 'AgentRating',
      component: AgentRating,
      meta: {
        accessId: Access.Agents
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/agents/activity',
      name: 'AgentActivity',
      component: AgentActivity,
      meta: {
        accessId: Access.Agents
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/agents/single/:date/:id',
      name: 'AgentSingle',
      component: AgentSingle,
      meta: {
        accessId: Access.Agents
      },
      beforeEnter: AuthGuard
    },

    {
      path: '/drivers/rating',
      name: 'DriverRating',
      component: DriverRating,
      meta: {
        accessId: Access.Drivers
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/drivers/activity',
      name: 'DriverActivity',
      component: DriverActivity,
      meta: {
        accessId: Access.Drivers
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/drivers/single/:date/:id',
      name: 'DriverSingle',
      component: DriverSingle,
      meta: {
        accessId: Access.Drivers
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/points/active',
      name: 'PointListActive',
      component: PointList,
      meta: {
        accessId: Access.Points
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/points/archive',
      name: 'PointListArchive',
      component: PointList,
      meta: {
        accessId: Access.Points
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/points/edit/:id',
      name: 'PointEdit',
      component: PointEdit,
      meta: {
        accessId: Access.Points
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/points/request/active',
      name: 'PointRequestListActive',
      component: PointRequestList,
      meta: {
        accessId: Access.Points
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/points/request/archive',
      name: 'PointRequestListArchive',
      component: PointRequestList,
      meta: {
        accessId: Access.Points
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/points/single/:id',
      name: 'PointSingle',
      component: PointSingle,
      meta: {
        accessId: Access.Points
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/points/request/logistics/list',
      name: 'PointLogisticsList',
      component: PointRequestLogisticsList,
      meta: {
        accessId: Access.Points
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/points/request/security/list',
      name: 'PointRequestSecurityList',
      component: PointRequestSecurityList,
      meta: {
        accessId: Access.Points
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/points/security/edit/:id',
      name: 'PointSecurityEdit',
      component: PointSecurityEdit,
      meta: {
        accessId: Access.Points
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/points/logistics/edit/:id',
      name: 'PointLogisticsEdit',
      component: PointLogisticsEdit,
      meta: {
        accessId: Access.Points
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/points/logistics/single/:id',
      name: 'PointLogisticsSingle',
      component: PointLogisticsSingle,
      meta: {
        accessId: Access.Points
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/statistics/branch',
      name: 'StatisticsBranch',
      component: StatisticsBranch,
      meta: {
        accessId: Access.Statistics
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/statistics/sale-group',
      name: 'StatisticsSaleGroup',
      component: StatisticsSaleGroup,
      meta: {
        accessId: Access.Statistics
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/statistics/agent',
      name: 'StatisticsAgent',
      component: StatisticsAgent,
      meta: {
        accessId: Access.Statistics
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/statistics/distribution-channel',
      name: 'StatisticsDistributionChannel',
      component: StatisticsDistributionChannel,
      meta: {
        accessId: Access.Statistics
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/statistics/point',
      name: 'StatisticsPoint',
      component: StatisticsPoint,
      meta: {
        accessId: Access.Statistics
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/statistics/product-category',
      name: 'StatisticsProductCategory',
      component: StatisticsProductCategory,
      meta: {
        accessId: Access.Statistics
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/statistics/product-brand',
      name: 'StatisticsProductBrand',
      component: StatisticsProductBrand,
      meta: {
        accessId: Access.Statistics
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/statistics/product-sku',
      name: 'StatisticsProductSku',
      component: StatisticsProductSku,
      meta: {
        accessId: Access.Statistics
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      meta: {
        accessId: Access.Settings
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/chat',
      name: 'Chat',
      component: Chat,
      meta: {
        accessId: Access.Chat
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/product/stock/setting/active',
      redirect: '/product/stock/setting/active/1',
      beforeEnter: AuthGuard
    },
    {
      path: '/product/stock/setting/active/:page',
      name: 'ProductStockSettingActive',
      component: ProductStockSettingList,
      meta: {
        accessId: Access.ProductStockSetting
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/product/stock/setting/new',
      name: 'ProductStockSettingNew',
      component: ProductStockSettingNew,
      meta: {
        accessId: Access.ProductStockSetting
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/product/stock/setting/edit/:id',
      name: 'ProductStockSettingEdit',
      component: ProductStockSettingNew,
      meta: {
        accessId: Access.ProductStockSetting
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/product/stock/setting/single/:id',
      name: 'ProductStockSettingSingle',
      component: ProductStockSettingSingle,
      meta: {
        accessId: Access.ProductStockSetting
      },
      beforeEnter: AuthGuard
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js